/* prettier-ignore */
export const content = {
  'designer.design-modes.components.selector.tooltip.label': 'Currently in {{mode}} mode',
  'designer.design-modes.components.selector.request-design.label': 'Request design control',
  'designer.design-modes.components.selector.request-design-to-oneself.description': 'You\'re designing in another tab',
  'designer.design-modes.components.selector.request-design.description': '{{activeUser}} currently has design control',
  'designer.design-modes.components.selector.take-design.label': 'Take design control',
  'designer.design-modes.components.selector.take-design.description': 'Merge a branch or design main site',
  'designer.design-modes.components.selector.branch-design.label': 'Design branch',
  'designer.design-modes.components.selector.branch-design.description': 'Design without affecting main site',
  'designer.design-modes.components.selector.design.label': 'Design',
  'designer.design-modes.components.selector.design.description': 'Style elements and build layouts',
  'designer.design-modes.components.selector.build.label': 'Build',
  'designer.design-modes.components.selector.build.description': 'Build pages with components and edit content',
  'designer.design-modes.components.selector.edit.label': 'Edit',
  'designer.design-modes.components.selector.edit.description': 'Edit static and dynamic content',
  'designer.design-modes.components.selector.view.label': 'View',
  'designer.design-modes.components.selector.view.description': 'Unable to make changes to main site',
  'designer.design-modes.components.selector.create-branch.label': 'Create page branch',
  'designer.design-modes.components.selector.create-branch.description': 'Design without affecting main site',
  
  'designer.design-modes.components.trigger.designing-branch.label': 'Design',
  'designer.design-modes.components.trigger.designing.label': 'Design',
  'designer.design-modes.components.trigger.page-building.label': 'Build',
  'designer.design-modes.components.trigger.content-editing.label': 'Edit',
  'designer.design-modes.components.trigger.editing.label': 'Edit',
  'designer.design-modes.components.trigger.viewing.label': 'View',
}
